//#region src/payment-processors/razorpay/constants/index.ts
var e = "https://checkout.razorpay.com/v1/checkout.js";
//#endregion
export { e as RAZORPAY_SCRIPT };
